import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

const { borderRadius, color } = theme;
const {
  designSystem: { purple70, blackOpacity60 },
  white,
} = color;

export const Container = styled.div<{ top: number }>`
  padding-left: 0;
  box-sizing: border-box;
  padding-top: ${({ top }) => top}px;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

type Position = {
  top: string;
  left: string;
};

export const DropdownContainer = styled.div<{ position: Position }>`
  border-radius: ${borderRadius.medium};
  background: ${white};
  box-shadow:
    0px 6px 10px rgba(0, 0, 0, 0.14),
    0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 3px 5px rgba(0, 0, 0, 0.2);
  min-width: 200px;
  overflow: hidden;
  position: fixed;
  z-index: 1500;
  left: 18px;

  ul {
    padding: 0;
  }

  ${({ position: { top, left } }) =>
    `left: ${left};
    top: ${top};
    `}
`;

export const PlusButton = styled.button<{
  isSelected: boolean;
  visible: boolean;
}>`
  outline: none;
  position: relative;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  ${({ isSelected, visible }) =>
    (isSelected || visible) && 'visibility: visible !important;'};

  svg path {
    fill: ${({ isSelected }) => (isSelected ? purple70 : blackOpacity60)};
  }

  &:hover:before,
  &:focus:before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    width: 24px;
    height: 24px;
    border-radius: ${theme.borderRadius.medium};
  }

  &:hover:before {
    background-color: ${theme.color.designSystem.background.lightPurple.hover};
  }

  &:focus:before {
    box-shadow: inset 0 0 0 1px ${theme.color.designSystem.blackOpacity87};
    background-color: ${theme.color.designSystem.background.lightPurple.focus};
  }

  &:hover,
  &:focus {
    path {
      fill: ${purple70};
    }
  }
`;
